"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const logging_1 = require("../logging");
exports.default = (key, initialValue) => {
    // tslint:disable-next-line: ban-types
    const isFunction = (arg) => typeof arg === 'function';
    const [storedData, setStoredData] = React.useState(() => {
        const init = isFunction(initialValue) ? initialValue() : initialValue;
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : init;
        }
        catch (error) {
            logging_1.logging.error(error);
            return init;
        }
    });
    const setValue = (value) => {
        try {
            const v = isFunction(value) ? value() : value;
            setStoredData(v);
            window.localStorage.setItem(key, JSON.stringify(v));
        }
        catch (error) {
            logging_1.logging.error(error);
        }
    };
    return [storedData, setValue];
};
//# sourceMappingURL=localStorage.js.map